import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from Reddit Ads reports by configuring it as a source in PostHog. The supported reports that can be synced include Ad Groups, Campaigns, Ads, Ad Group Report, Campaign Report, and Ad Report, as described here:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/List%20Ad%20Groups"
        }}>{`Ad Groups`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/List%20Campaigns"
        }}>{`Campaigns`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/List%20Ads"
        }}>{`Ads`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/Get%20A%20Report"
        }}>{`Ad Groups Report`}</a>{`: Report broken down by `}<inlineCode parentName="li">{`AD_GROUP_ID`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/Get%20A%20Report"
        }}>{`Campaign Report`}</a>{`: Report broken down by `}<inlineCode parentName="li">{`CAMPAIGN_ID`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ads-api.reddit.com/docs/v3/operations/Get%20A%20Report"
        }}>{`Ad Report`}</a>{`: Report broken down by `}<inlineCode parentName="li">{`AD_ID`}</inlineCode></li>
    </ul>
    <p>{`Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`A Reddit Ads account with permission to access data from accounts you want to sync.`}</li>
      <li parentName="ul">{`Your account ID from the `}<a parentName="li" {...{
          "href": "https://ads.reddit.com/business/"
        }}>{`business manager app`}</a>{` > Menu > Assets > Ad Accounts > get the ID`}</li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/Screenshot_2025_09_11_at_7_01_43_PM_c31b74db4c.png" classes="rounded" alt="Reddit account ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your Reddit Ads account using a Reddit account. The Reddit account must have permission to access data.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find Reddit Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Account ID`}</strong>{` of the Reddit Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing Reddit Ads account, or create a new integration`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      